import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Mutation } from 'react-apollo'
import { withRouter } from 'react-router'
import { SEND_ACTIVATION_MAIL } from '../../mutations'

import DeletePopup from '../../components/DeletePopup/'
import { Dots, Cross, ColorBean } from '../../components/Icons'
import { Row, Item, Sup, Editor, DotsContainer, Dropdown, DropdownItem, CloseButton } from './styles'

class TableRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupActive: false,
      active: false
    }
  }

  toggleEdit() {
    this.setState({ active: !this.state.active })
  }

  handleDelete() {
    this.setState({
      popupActive: true,
      active: !this.state.active
    })
  }

  handleEdit(item) {
    this.setState({ active: !this.state.active })
    this.props.onEditClick(item)
  }

  closePopup() {
    this.setState({ popupActive: false })
  }

  render() {
    let {
      headers,
      item,
      editable,
      editType,
      deleteTitle,
      deleteConfirm,
      deleteReject,
      deleteUser,
      data,
      loading,
      error,
      editUserPermission,
      deleteUserPermission,
      fullUser,
      currentUser
    } = this.props
    editable = fullUser.role !== 'MANAGER' ? editable : false
    editable = currentUser !== item.id ? editable : false
    return (
      <Row key={item.id} currentUser={currentUser === item.id} noPadding={editable || fullUser.role === 'MANAGER'}>
        <Item>
          <Sup>{headers[0]}</Sup>
          {typeof item.one === 'string' ? item.one : item.one}
        </Item>
        <Item>
          <Sup>{headers[1]}</Sup>
          {typeof item.two === 'string' ? item.two : item.two}
        </Item>
        <Item>
          <Sup>{headers[2]}</Sup>
          {typeof item.three === 'string' ? item.three : item.three}
        </Item>
        <Item>
          <Sup>{headers[3]}</Sup>
          {item.four.content === 'Verstuur activatielink' ? (
            <Mutation
              mutation={SEND_ACTIVATION_MAIL}
            >
              {(sendActivationMail, { data, loading, error }) => {
                if (data) {
                  return <Fragment>Activatiemail verstuurd</Fragment>
                }
                return (
                  <Fragment>
                    <a href="" onClick={(e) => {
                      e.preventDefault()
                      sendActivationMail({
                        variables: {
                          data: {
                            id: item.id
                          }
                        }
                      })
                    }}>
                      {item.four.content}
                    </a>
                  </Fragment>
                )
              }}
            </Mutation>
          ) : (
            <Fragment>
              {typeof item.four === 'string' ? item.four : (item.four.link ? <a href={item.four.link}>{item.four.content}</a> : item.four.content)}
            </Fragment>
          )}
          
        </Item>

        <Item active={this.state.active}>
          {editable ? (
            <Editor onClick={this.toggleEdit.bind(this)}>
              <DotsContainer>
                <Dots size="" />
              </DotsContainer>
            </Editor>
          ) : null}

          {fullUser.role === 'MANAGER' ? (
            <Editor manager={fullUser.role === 'MANAGER'}>
              <DotsContainer>
                <ColorBean size="" />
              </DotsContainer>
            </Editor>
          ) : null}

          <Dropdown>
            {editUserPermission ? (
              <Fragment>
                {editType === 'user' ? (
                  <DropdownItem>
                    <Link to={`/medewerkers/${item.id}/bewerken`}>Bewerk</Link>
                  </DropdownItem>
                ) : (
                  <DropdownItem onClick={this.handleEdit.bind(this, item)}>Wijzigen</DropdownItem>
                )}
              </Fragment>
            ) : null}

            {deleteUserPermission ? (
              <DropdownItem onClick={this.handleDelete.bind(this)}>Verwijder</DropdownItem>
            ) : null}

            <CloseButton onClick={this.toggleEdit.bind(this)}>
              <Cross size="xlarge" />
            </CloseButton>
          </Dropdown>

          {this.state.popupActive ? (
            <DeletePopup
              closePopup={this.closePopup.bind(this)}
              id={item.id}
              title={deleteTitle}
              confirm={deleteConfirm}
              deny={deleteReject}
              deleteUser={deleteUser}
              data={data}
              loading={loading}
              error={error}
            />
          ) : null}
        </Item>
      </Row>
    )
  }
}

export default withRouter(TableRow)



// WEBPACK FOOTER //
// ./src/components/TableRow/index.js